module.exports = __webpack_public_path__ + "static/img/img-top-sp.a1bb1bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img-top-sp.jpg
// module id = KLtg
// module chunks = 0